import { Routes, RouterModule } from '@angular/router';
import { MetaGuard } from '@ngx-meta/core';

import { GraduacaoComponent } from './graduacao.component';
import { CursosComponent } from './cursos/cursos.component';
import { CursoDetalheComponent } from './cursos/curso-detalhe/curso-detalhe.component';
import { EnadeComponent } from './enade/enade.component';
import { CondicoesOfertaCursoComponent } from './condicoes-oferta-curso/condicoes-oferta-curso.component';
import { ValidaDocumentosComponent } from './valida-documentos/valida-documentos.component';
import { ConsultaEmailComponent } from './consulta-email/consulta-email.component';
import { environment } from '../../environments/environment';
import { fiesProuniComponent } from './fies-prouni/fies-prouni.component';

const GRADUCACAO_ROUTER: Routes = [
  {
    path: '',
    canActivateChild: [MetaGuard],
    component: GraduacaoComponent,
    children: [
      {
        path: '',
        component: CursosComponent,
        data: {
          meta: {
            title:(environment.loginContexto=='EURO'||environment.loginContexto=='CEUMA'||environment.loginContexto=='FAMAZ')? 'Estude no '+environment.title: 'Estude na '+environment.title,
            description: `Conheça os cursos${environment.loginContexto=='CEUMA'?' da melhor Universidade do Maranhão':''}.`,
          },
        },
      },
      {
        path: 'humanas',
        component: CursosComponent,
        data: {
          meta: {
            title: (environment.loginContexto=='EURO'||environment.loginContexto=='CEUMA'||environment.loginContexto=='FAMAZ')? 'Estude no '+environment.title: 'Estude na '+environment.title,
            description: `Conheça os cursos da área de humanas${environment.loginContexto=='CEUMA'?' da melhor Universidade do Maranhão':''}.`,
          },
        },
      },
      {
        path: 'exatas',
        component: CursosComponent,
        data: {
          meta: {
            title: (environment.loginContexto=='EURO'||environment.loginContexto=='CEUMA'||environment.loginContexto=='FAMAZ')? 'Estude no '+environment.title: 'Estude na '+environment.title,
            description: `Conheça os cursos da área de exatas${environment.loginContexto=='CEUMA'?' da melhor Universidade do Maranhão':''}.`,
          },
        },
      },
      {
        path: 'saude',
        component: CursosComponent,
        data: {
          meta: {
            title: (environment.loginContexto=='EURO'||environment.loginContexto=='CEUMA'||environment.loginContexto=='FAMAZ')? 'Estude no '+environment.title: 'Estude na '+environment.title,
            description: `Conheça os cursos da área de saúde${environment.loginContexto=='CEUMA'?' da melhor Universidade do Maranhão':''}.`,
          },
        },
      },
      {
        path: 'enade',
        component: EnadeComponent,
        data: {
          meta: {
            title: 'Por dentro do Enade',
            description: 'Entenha como funciona e saiba todos os detalhes sobre o Enade.',
          },
        },
      },
      {
        path: 'condicoes-oferta-curso',
        component: CondicoesOfertaCursoComponent,
        data: {
          meta: {
            title: 'Condições de Oferta de Curso',
            description: 'Descrição das Condições de Oferta de Curso',
          },
        },
      },
      {
        path: 'valida-documentos',
        component: ValidaDocumentosComponent,
        data: {
          meta: {
            title: 'Consulta de Formados',
            description: 'Consulta de Formados',
          },
        },
      },
      {
        path: 'consulta-email',
        component: ConsultaEmailComponent,
        data: {
          meta: {
            title: 'Consulta de Email',
            description: 'Consulta de Email',
          },
        },
      },
      {
        path: 'fies-prouni',
        component: fiesProuniComponent,
        data: {
          meta: {
            title: 'Fies/Prouni',
            description: '',
          },
        },
      },
      {
        path: ':curso',
        component: CursoDetalheComponent,
      },
    ],
  },
];

export const GraduacaoRouter = RouterModule.forChild(GRADUCACAO_ROUTER);
